<template>
  <filter-wrapper @submit="submit">
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('mailer.stats.general.filter.group_by.title') }}
        </label>
        <div class="filter__item__body">
          <mailings-stats-filter-input-group v-model="form.group_by" />
        </div>
      </div>
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('mailer.stats.general.filter.source.title') }}
        </label>
        <div class="filter__item__body">
          <mailings-input-source v-model="form.source" />
        </div>
      </div>

      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('mailer.stats.general.filter.sender.title') }}
        </label>
        <div class="filter__item__body">
          <mailings-stats-filter-input-sender v-model="form.sender" />
        </div>
      </div>
    </div>

    <div class="filter__row">
      <div class="filter__item filter__item--datepicker">
        <label class="filter__item__title">
          {{ $t('shared.component.filter.period') }}
        </label>
        <div class="filter__item__body">
          <date-range-picker v-model="form.date" />
        </div>
      </div>

      <div class="filter__item filter__item--button">
        <i-button html-type="submit" type="primary">
          {{ $t('shared.component.filter.show_result') }}
        </i-button>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import { mapActions } from 'vuex';
  import { initSearchStateByPeriod, parseSearchStateByPeriod } from '@shared/helpers/date_format';
  import FilterWrapper from '@shared/components/filter-base';
  import MailingsStatsFilterInputGroup from '@mailer/components/stats/mailings-stats-filter-input-group';
  import MailingsStatsFilterInputSender from '@mailer/components/stats/mailings-stats-filter-input-sender';
  import MailingsInputSource from '@mailer/components/mailings/mailings-input-source';

  export default {
    components: {
      MailingsInputSource,
      MailingsStatsFilterInputGroup,
      MailingsStatsFilterInputSender,
      FilterWrapper
    },
    data: () => ({
      form: {
        group_by: 'day',
        source: null,
        sender: '',
        date: initSearchStateByPeriod()
      }
    }),
    created() {
      this.submit();
    },

    methods: {
      ...mapActions('mailer/stats/general', ['search']),

      submit: function () {
        const { start, end } = parseSearchStateByPeriod(this.form.date);
        const { group_by, source, sender } = this.form;

        const params = {
          group_by,
          source,
          sender,
          type: 'all',
          date_from: start,
          date_to: end
        };

        this.search(params);
      }
    }
  };
</script>
<style lang="scss">
  .filter__item--datepicker {
    margin-right: 30px;
  }
</style>
